import React from 'react';
import BaseComponent from '../BaseComponent';
import styles from '../atoms.module.scss';

export default class WeekDaysHorizontalGroup extends BaseComponent<any, any> {
  renderView(): JSX.Element {
    return <div className={styles.weekDayHorizontalContainer}>{this.props.children}</div>;
  }
}
